import { useEffect, useState } from "react";

import { fieldNames } from "../utilities/constants";
import { Tool, sortTools } from "../utilities/utils";

const { CATALOGUES } = fieldNames;

function ChineseTools(props) {
  const [data, setData] = useState([]);
  const [chineseTools, setChineseTools] = useState(3);

  useEffect(() => {
    let data = [];
    props.records.forEach((record) => {
      const catalogues = record.get(CATALOGUES);
      if (catalogues && catalogues.includes("Chinese Tools")) {
        data.push(record);
      }
    });

    const sortedData = sortTools(data, props.sortInfo);

    setData(sortedData);
  }, [props.sortInfo, props.records]);

  const card = data.slice(0, chineseTools).map((i) => Tool(i));
  return (
    <div id="chinese-tools-container">
      {card}
      {data.length === null || chineseTools >= data.length ? null : (
        <button onClick={() => setChineseTools(chineseTools + 3)}>
          see more
        </button>
      )}
    </div>
  );
}

export default ChineseTools;
